// src/utils/Theme.js - Green & Black Web3 Developer Theme

export const darkTheme = {
    // Core backgrounds - Pure black
    bg: "#000000",
    bgLight: "#0a0a0a",

    // Primary Green colors - Custom #37c164
    primary: "#37c164",         // Custom green
    accent: "#2da855",          // Darker shade
    secondary: "#258a47",       // Even darker
    tertiary: "#5cd488",        // Lighter mint

    // Text colors
    text_primary: "#f0f0f0",
    text_secondary: "#a8a8a8",
    text_tertiary: "#37c164",

    // Card backgrounds
    card: "#0a0a0a",
    card_light: '#111111',

    // Button and Interactive
    button: "#37c164",
    white: "#FFFFFF",
    black: "#000000",

    // Enhanced Glassmorphism
    glass: "rgba(10, 10, 10, 0.8)",
    glass_border: "rgba(55, 193, 100, 0.15)",
    glass_hover: "rgba(55, 193, 100, 0.08)",

    // Neon Shadows - Green glow
    shadow_primary: "rgba(55, 193, 100, 0.3)",
    shadow_accent: "rgba(45, 168, 85, 0.2)",
    shadow_glow: "rgba(55, 193, 100, 0.5)",

    // Green Gradients
    gradient_primary: "linear-gradient(135deg, #37c164 0%, #2da855 50%, #258a47 100%)",
    gradient_secondary: "linear-gradient(135deg, #2da855 0%, #37c164 100%)",
    gradient_accent: "linear-gradient(135deg, #37c164 0%, #5cd488 100%)",
    gradient_text: "linear-gradient(90deg, #37c164, #5cd488, #37c164)",
    gradient_hero: "radial-gradient(ellipse at bottom, #0a120d 0%, #000000 100%)",
    gradient_card: "linear-gradient(135deg, rgba(55, 193, 100, 0.05) 0%, rgba(45, 168, 85, 0.05) 100%)",

    // Status colors
    success: "#37c164",
    warning: "#ffcc00",
    error: "#ff4444",
}

export const lightTheme = {
    // Core backgrounds
    bg: "#f5fff8",
    bgLight: "#ffffff",

    // Primary colors - Darker for light mode
    primary: "#2da855",
    accent: "#258a47",
    secondary: "#1d7039",
    tertiary: "#37c164",

    // Text colors
    text_primary: "#0a0a0a",
    text_secondary: "#333333",
    text_tertiary: "#2da855",

    // Card backgrounds
    card: "#ffffff",
    card_light: '#f0fff4',

    // Button and Interactive
    button: "#2da855",
    white: "#FFFFFF",
    black: "#000000",

    // Glassmorphism for light mode
    glass: "rgba(255, 255, 255, 0.9)",
    glass_border: "rgba(45, 168, 85, 0.2)",
    glass_hover: "rgba(45, 168, 85, 0.1)",

    // Shadows
    shadow_primary: "rgba(45, 168, 85, 0.25)",
    shadow_accent: "rgba(37, 138, 71, 0.2)",
    shadow_glow: "rgba(45, 168, 85, 0.4)",

    // Gradients
    gradient_primary: "linear-gradient(135deg, #2da855 0%, #258a47 50%, #1d7039 100%)",
    gradient_secondary: "linear-gradient(135deg, #258a47 0%, #2da855 100%)",
    gradient_accent: "linear-gradient(135deg, #2da855 0%, #37c164 100%)",
    gradient_text: "linear-gradient(90deg, #2da855, #258a47, #1d7039)",
    gradient_hero: "radial-gradient(ellipse at bottom, #e8fff0 0%, #f5fff8 100%)",
    gradient_card: "linear-gradient(135deg, rgba(45, 168, 85, 0.05) 0%, rgba(37, 138, 71, 0.05) 100%)",

    // Status colors
    success: "#2da855",
    warning: "#cc9900",
    error: "#cc0000",
}